<template>
    <div class="msg">
        <my-header></my-header>
        <el-row :span="24" class="bg-color">
            <!-- <el-col :span="4" ><div>&nbsp;</div></el-col> -->
            <el-col :span="16" :xs="{span:20,offset:2}" :sm="{span:16,offset:4}" :md="{span:16,offset:4}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <el-row :span="24" class="msg_list">
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
            <el-col :span="16" :xs="{span:20,offset:2}" :sm="{span:16,offset:4}" :md="{span:16,offset:4}">
                <div class="member_hyzx">
                    <ul class="hyzx_left">
                        <!-- <li @click="num = 1" :class="{active :num == 1}" ><i class="el-icon-info"></i> &nbsp;我的发布</li> -->
                        <li @click="num = 1" :class="{active :num == 1}"><i class="el-icon-chat-dot-square"></i> &nbsp;站内消息</li>
                    </ul>
                    <!-- <div v-show="num==1" class="hyzx_right">
                        
                        <div v-if="show">

                            <div class="msglist"  v-if="showedstyle">
                                <div class="msg_all">
                                    <div class="msg_title">我的发布</div>
                                    <el-button type="primary" @click="newMsg()" class="newbtn" v-if="show">新的发布</el-button>
                                    <ul  v-for="(list,n) in msgList" :key="n">
                                        <li>{{list.title}}<span style="display:block;">{{list.addtime}}</span></li>
                                        <li>文章分类  
                                            <span style="display:block;" v-if="list.type === 'LAW'">法律</span>
                                            <span style="display:block;" v-if="list.type === 'FINANCE'">金融</span>
                                            <span style="display:block;" v-if="list.type === 'LOGISTICS'">物流</span>
                                            <span style="display:block;" v-if="list.type === 'EXHIBTION'">展会</span>
                                            <span style="display:block;" v-if="list.type === 'LEASE'">租赁共享</span>
                                            <span style="display:block;" v-if="list.type === 'BUSINESS'">商务考察</span>
                                            <span style="display:block;" v-if="list.type === 'TRANSLATE'">翻译公证</span>
                                            <span style="display:block;" v-if="list.type === 'AID'">企业互助</span>
                                            <span style="display:block;" v-if="list.type === 'TALENT'">人才交流</span>
                                            <span style="display:block;" v-if="list.type === 'CHARITABLE'">慈善文化</span>
                                            <span style="display:block;" v-if="list.type === 'YDYL'">一带一路</span>
                                            <span style="display:block;" v-if="list.type === 'POLICY'">政策共享</span>
                                        </li>
                                        <li>审核状态  
                                            <span v-if="list.articalCheck == 0">审核通过</span>
                                            <span v-if="list.articalCheck == 1">未通过</span>
                                            <span v-if="list.articalCheck == 2">审核中</span>
                                        </li>
                                        <li>
                                            <el-button type="danger" plain v-if="list.issubmit == 1" @click="getDel(list)">删除</el-button>
                                            <span v-if="list.issubmit == 0">删除申请中</span>
                                        </li>
                                    </ul>
                                    <div>
                                        <el-pagination
                                            background
                                            @current-change="currentChange"
                                            :page="page"
                                            :page-size="pageSize"
                                            layout="prev, pager, next"
                                            :total="total">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                            <div class="smallmsglist" v-if="showstyle">
                                <div class="smallmsg_all">
                                    <div class="smallmsg_title">我的发布</div>
                                    <el-button type="primary" @click="newMsg()" class="newbtn" v-if="show">新的发布</el-button>
                                    <ul  v-for="(list,n) in msgList" :key="n">
                                        <li>{{list.title}}<span style="display:block;">{{list.addtime}}</span></li>
                                        <li>文章分类  
                                            <span style="display:block;" v-if="list.type === 'LAW'">法律</span>
                                            <span style="display:block;" v-if="list.type === 'FINANCE'">金融</span>
                                            <span style="display:block;" v-if="list.type === 'LOGISTICS'">物流</span>
                                            <span style="display:block;" v-if="list.type === 'EXHIBTION'">展会</span>
                                            <span style="display:block;" v-if="list.type === 'LEASE'">租赁共享</span>
                                            <span style="display:block;" v-if="list.type === 'BUSINESS'">商务考察</span>
                                            <span style="display:block;" v-if="list.type === 'TRANSLATE'">翻译公证</span>
                                            <span style="display:block;" v-if="list.type === 'AID'">企业互助</span>
                                            <span style="display:block;" v-if="list.type === 'TALENT'">人才交流</span>
                                            <span style="display:block;" v-if="list.type === 'CHARITABLE'">慈善文化</span>
                                            <span style="display:block;" v-if="list.type === 'YDYL'">一带一路</span>
                                            <span style="display:block;" v-if="list.type === 'POLICY'">政策共享</span>
                                        </li>
                                        <li>审核状态  
                                            <span v-if="list.articalCheck == 0">审核通过</span>
                                            <span v-if="list.articalCheck == 1">未通过</span>
                                            <span v-if="list.articalCheck == 2">审核中</span>
                                        </li>
                                        <li>
                                            <el-button type="danger" plain v-if="list.issubmit == 1" @click="getDel(list)">删除</el-button>
                                            <span v-if="list.issubmit == 0">删除申请中</span>
                                        </li>
                                    </ul>
                                    <div>
                                        <el-pagination
                                            background
                                            @current-change="currentChange"
                                            :page="page"
                                            :page-size="pageSize"
                                            layout="prev, pager, next"
                                            :total="total">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="release">
                            <div style="width:100$;height:30px;background-color:#1f3356;color:#fff;line-height:30px;box-sizing:border-box;padding:0 10px;">新建发布</div>
                            <div>
                                <div>发布分类</div>
                                <el-select v-model="value" placeholder="请选择">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <div>发布标题</div>
                                <el-input v-model="input" placeholder="请输入内容" maxlength="40"></el-input>
                            </div>
                            <div>
                                <div>发布内容</div>
                                <quill-editor 
                                    v-model="content"
                                    ref="myTextEditor"
                                    :options="editorOption"
                                    style="height:100px;"
                                    @blur="onEditorBlur($event)"
                                    @focus="onEditorFocus($event)"
                                    @change="onEditorChange($event)">
                                </quill-editor>
                                <el-button type="primary" @click="saveMsg()" style="margin-top:40px;">发布</el-button>
                                <el-button type="primary" plain @click="back()" style="margin-top:40px;">取消</el-button>
                            </div>
                        </div>
                    </div> -->
                    <div v-show="num==1" class="hyzx_right">
                        <div class="msg_znxx">
                            <div class="msg_title">站内消息</div>
                            <div v-if="siteMsg.length == 0">
                                <span>当前暂无站内消息</span>
                            </div>
                            <div>
                                <ul v-for="(list,i) in siteMsg" :key="i" class="msg_lists">
                                    <li class="znxx_title">
                                        <span v-if="list.messageType == 0">发布反馈</span> 
                                        <span v-if="list.messageType == 1">删除反馈</span> 
                                        <!-- <span class="znxx_time">{{list.messageAddtime}}</span> -->
                                    </li>
                                    <li class="znxx_time"><i class="el-icon-time"></i>{{list.messageAddtime}}</li>
                                    <li class="znxx_msg">{{list.message}}  </li>
                                    <!-- <li></li> -->
                                    <!-- <li class="znxx_ckxq"><span>查看详情>></span></li> -->
                                    <!-- <li @click="getMsgdetail(list.id)" type="primary">
                                        查看详情>>
                                    </li>
                                    <el-drawer class="msgdeta"
                                        title="我是标题"
                                        :visible.sync="drawer"
                                        :with-header="false">
                                        <span>{{msgDetail}}</span>
                                    </el-drawer> -->
                                </ul>
                                <div  v-if="siteMsg.length != 0">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :page="msgpage"
                                        :page-size="msgpageSize"
                                        @current-change="handleCurrentChange"
                                        :total="msgtotal">
                                    </el-pagination>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </el-col>
            <!-- <el-col :span=4><div>&nbsp;</div></el-col> -->
        </el-row>
        <my-footer></my-footer>
    </div>
</template>

<script>
import MyHeader  from '@/components/headerPage'
import MyFooter  from '@/components/footerPage'
import { quillEditor } from 'vue-quill-editor'
import quillConfig from '../../untils/quill-config'

export default {
    components:{MyHeader,quillEditor,MyFooter},
    data() {
        return {
            changeRed:0,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
            content:'',
            editorOption:quillConfig,
            num:1,
            show:true,
            drawer: false, //站内消息查看详情
            msgList:[],
            // msgList:[
            //     {
            //         title:'文章文章文章文章',
            //         adopt:'审核通过',
            //         time:"2020-04-29",
            //     },{
            //         title:'文章文章文章文章',
            //         adopt:'审核通过',
            //         time:"2020-04-29",
            //     },{
            //         title:'文章文章文章文章',
            //         adopt:'审核通过',
            //         time:"2020-04-29",
            //     },
            // ],
            
            siteMsg:[],
            options:[],
            input:"",
            // options: [{
            //     value: '选项1',
            //     label: '黄金糕'
            // }, {
            //     value: '选项2',
            //     label: '双皮奶'
            // }, {
            //     value: '选项3',
            //     label: '蚵仔煎'
            // }, {
            //     value: '选项4',
            //     label: '龙须面'
            // }, {
            //     value: '选项5',
            //     label: '北京烤鸭'
            // }],
            value: '',
            page:1,
            pageSize:10,
            total:0,
            userId:sessionStorage.getItem('userId'),
            msgDetail:'',
            msgpage:1,
            msgpageSize:10,
            msgtotal:0,
            showstyle:false,
            showedstyle:true,
            
        }
    },
    mounted() {
        
        this.newStation();
        this.getArticalType();
        this.getPublic();
        var w = document.documentElement.clientWidth;
        if(w < 768){
            this.showstyle = true;
            this.showedstyle = false;
        }else{
            this.showstyle = false
            this.showedstyle =true
        }
    },
    methods: {
        back(){
            this.show= true;
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getPublic();
        },
        currentChange(page) {
            this.page = page;
            // this.Lmmature();
            this.getPublic();
        },
        onEditorBlur(editor){//失去焦点事件 

        },
        onEditorFocus(editor){//获得焦点事件

        },
        onEditorChange({editor,html,text}){//编辑器文本发生变化
            //this.content可以实时获取到当前编辑器内的文本内容
            // console.log(this.content);
        },
        newMsg(){
            this.show =! this.show;
        },
        //发布信息
        saveMsg(e){
            if(!this.value){
                this.$message.error('请选择发布分类');
                return
            }
            if(!this.input){
                this.$message.error('请输入发布标题');
                return
            }
            if(!this.content){
                this.$message.error('请输入需要发布的内容');
                return
            }
            this.$confirm('确定发布信息吗?, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$axios.post('/saveArtical',{
                    userId:this.userId,
                    type:this.value,
                    title:this.input,
                    content:this.content,
                }).then(res=>{
                    this.show = true;
                    this.getPublic();
                }).catch(err=>{
                })
                this.value="";
                this.input="";
                this.content="";
            }).catch(() => {        
            });
        },
        //站内消息
        newStation(){
            let token = sessionStorage.getItem('token');
            this.$axios.get('/getMessages/'+this.page+'/'+this.pageSize+'/'+this.userId,{
                headers:{
                    token:'russia'+token
                }
            }).then(res=>{
                let resList = res.data.data;
                this.total = resList.total;
                this.siteMsg = resList.list
            })
        },
        //查看详情
        getMsgdetail(id){
            this.drawer =! this.drawer
            this.$axios.get('/getMessagesDetail/'+id).then(res=>{
                this.msgDetail = res.data.data.message;
            })
        },
        //发布分类的列表
        getArticalType(){
            this.$axios.get('/getArticalType').then (res=>{
                this.options = res.data.data;
                
            })
        },
        //发布列表
        getPublic(){
            this.$axios.get('/getPublishArticals/'+this.page+'/'+this.pageSize+'/'+this.userId).then(res=>{

                this.msgList = res.data.data.list;
                this.total = res.data.data.total;
            })
        },
        //列表详情
        getDetail(id){
            this.$axios.get('/getPublishArticalsDetail/'+id).then(res=>{
                // console.log(res)
            })
        },
        //删除
        getDel(list){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/delPublishArtical',{
                    userId:this.userId,
                    title:list.title,
                    mykey:list.id,
                }).then(res=>{
                    if(res.data.success){
                        this.$message({
                            type: 'success',
                            message: '删除申请成功!'
                        });
                        this.getPublic();
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
            
        },
        //站内消息分页
        handleCurrentChange(val){
            this.page = val;
            this.newStation();

        },
        //切换导航也
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },

    },
}
</script>
<style scoped >
.bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul{
        height:40px;
        margin:0 auto;
        
    }
    .nav ul li {
        float:left;
        width:25%;
        box-sizing: border-box;
        padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }



    .msg {
        width:100%;
        height:auto;
    }
    .msg .msg_list{
        margin-top:40px;
        min-height:900px;
    }
    .msg .member_hyzx{
        width:100%;
        height:100%;
    }
    .member_hyzx .hyzx_left{
        float:left;
        width:20%;
        height:auto;
    }
    .member_hyzx .hyzx_left li{
        min-width:130px;
        min-height:60px;
        text-align:center;
        line-height:60px;
        font-size:20px;
        background-color: #fff;
    }
    .member_hyzx .hyzx_left li.active{
        background-color: #FE9900;
        color:#fff;
    }

    /*  */
    .member_hyzx .hyzx_right{
        float:right;
        width:80%;
        /* margin-left:20px; */
        height:100%;
    }
    .hyzx_right .newbtn{
        margin:10px 10px;
    }
    .hyzx_right .msg{
        width:100%;
        height:auto;
        min-height:500px;
        text-align: center;
        line-height: 500px;
        font-size:30px;
        font-weight:600;
        
    }
    .hyzx_right .msg_title{
        width:100%;
        height:40px;
        line-height:40px;
        color:#fff;
        box-sizing: border-box;
        padding:0 20px;
        background-color: #1f3358;
    }
    .hyzx_right .msglist ul {
        /* width:100%; */
        height:auto;
        min-height:110px;
        
        text-align: center;
        margin:10px 10px 20px 10px;
        
        border-radius: 10px;
        background-color: #fff;
    }
    .hyzx_right .msglist .msg_all{
        width:100%;
        height:auto;
        min-height:700px;
        background-color: #eee;
    }
    .hyzx_right .msglist ul li{
        float:left;
        
        
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: justify;
        box-sizing: border-box;
        padding:20px 20px;
        /* margin:10px 0; */
    }
    .hyzx_right .msglist ul li:nth-child(1){
        width:50%;
        font-weight:600;
        
    }
    .hyzx_right .msglist ul li:nth-child(2){
        width:20%;
    }
    .hyzx_right .msglist ul li:nth-child(3),li:nth-child(4){
        width:10%;
        box-sizing: border-box;
        /* margin:10px 0; */
     }
    .hyzx_right .msglist ul span{
        display: block;
        color:#666;
        margin-top:6px;
        /* box-sizing: border-box;
        padding-top:10px; */
    }
    /* 手机端切换样式 */
    /* .hyzx_right .newbtn{
        margin:10px 10px;
    }
    .hyzx_right .msg{
        width:100%;
        height:auto;
        min-height:500px;
        text-align: center;
        line-height: 500px;
        font-size:30px;
        font-weight:600;
        
    }*/
    .hyzx_right .smallmsg_title{
        width:100%;
        height:40px;
        line-height:40px;
        color:#fff;
        box-sizing: border-box;
        padding:0 20px;
        background-color: #1f3358;
    } 
    .hyzx_right .smallmsglist ul {
        /* width:100%; */
        height:auto;
        min-height:110px;
        text-align: center;
        margin:10px 10px 20px 10px;
        border-radius: 10px;
        background-color: #fff;
    }
    .hyzx_right .smallmsglist .smallmsg_all{
        width:100%;
        height:auto;
        min-height:700px;
        background-color: #eee;
    }
    .hyzx_right .smallmsglist ul li{
        float:left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        box-sizing: border-box;
        padding:20px 20px;
    }
    .hyzx_right .smallmsglist ul li:nth-child(1){
        width:40%;
        font-weight:600;
        
    }
     .hyzx_right .smallmsglist ul li:nth-child(2),li:nth-child(3),li:nth-child(4){
        /* width:20%; */
        box-sizing: border-box;
        /* margin:10px 0; */
     }
    .hyzx_right .smallmsglist ul span{
        display: block;
        color:#666;
        margin-top:6px;
        /* box-sizing: border-box;
        padding-top:10px; */
    }
    /* 手机端切换样式 */
    .hyzx_right .hyzx{
        width:100%;
        height:200px;
        background-color: #f8f8f8;
    }
    .hyzx_right div img{
        float:left;
        width:250px;
        height:140px;
        margin: 28px 10px;
    }
    .hyzx_right .hyzx_title{
        font-size:20px;
        font-weight:600;
        color:#666;
        box-sizing: border-box;
        padding-top:30px;
    }
    .hyzx_right .hyzx_title span{
        color:#fff;
        background-color: #fe9900;
    }
    .hyzx_right .hyzx_message{
        color:#999;
        font-size:16px;
        box-sizing: border-box;
        padding-top:10px;
    }
     .hyzx_right .line_h{
        float: left;
        width:100%;
        height:1px;
        background-color: #ccc;
    }
    .msg_znxx {
        min-height:500px;
    }
    .msg_znxx .msg_lists{
        width:100%;
        height:auto; 
        min-height:140px; 
        box-sizing: border-box;
        padding:10px 20px;
        background-color: #eee; 
        margin:10px 0;
        border-radius: 10px;
    }
    .msg_znxx .msg_lists li{
        box-sizing: border-box;
        padding-top:10px;
    }
    .msg_znxx .msg_lists .znxx_title{
        color:#333;
        font-size:22px;
        font-weight: 600;
    }
    .msg_znxx .msg_lists .znxx_time{
        color:#999;
        font-size:16px;
    }
    .msg_znxx .msg_lists .znxx_msg{
        width:100%;
        color:#666;
        font-size:18px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
    }
    .msg_znxx .msg_lists .znxx_ckxq{
        color:#00f;
    }
    .msg_znxx .msgdeta{
        font-size:18px;
        line-height:30px;
    }
    .msg_znxx .msgdeta span{
        display:block;
        box-sizing: border-box;
        padding:10px 10px;
        margin:10px 0;
    }

    /* 发布消息 */
    .hyzx_right .release{
        width:100%;
        height:auto;
        min-height:700px;
    }
    .release div {
        margin-bottom:10px;
    }
    .release div div{
        display:block;
        
    }

   
    .el-pagination{
        float:right;
        margin-top:20px;
    }
    .el-pager li{
        font-size:22px;
    }

    .el-option{
        width:100%;
    }
    </style>


// WEBPACK FOOTER //
// src/components/msgPage.vue